var React = require('react');

function IconCloseButtonInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 8L8 24","stroke":"#8E4AFF","strokeWidth":"2.66667","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M8 8L24 24","stroke":"#8E4AFF","strokeWidth":"2.66667","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

IconCloseButtonInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = IconCloseButtonInline;

IconCloseButtonInline.default = IconCloseButtonInline;
